import type { BigQuerySyncPreviewDiffLineGql } from '@/graphql/types/bigQuerySyncPreview';
import { formatUnknownJson } from '@/services/bigQuerySyncPreview/formatUnknownJson';

export function filterBigQueryDiffLinesByQuery(
  lines: readonly BigQuerySyncPreviewDiffLineGql[],
  query: string
): BigQuerySyncPreviewDiffLineGql[] {
  const q = query.trim().toLowerCase();
  if (!q) return [...lines];

  return lines.filter((line) => {
    const haystack = [
      line.entity,
      line.op,
      formatUnknownJson(line.natural_key_json),
      formatUnknownJson(line.before_json),
      formatUnknownJson(line.after_json),
    ]
      .join('\n')
      .toLowerCase();
    return haystack.includes(q);
  });
}
